import { TokensMath } from '../../../Fct/plugins/tokensMath';
import createMulticallPlugin from './generic/createMulticallPlugin';
export var MultiAdd = createMulticallPlugin({
    plugin: TokensMath.getters.Add,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY:VIEWONLY',
    method: 'multiCall',
    name: 'multiAdd',
    config: {
        params: [
            { key: 'methodParams.amount1', multicallKey: 'amount1' },
            { key: 'methodParams.decimals1', multicallKey: 'decimals1' },
            { key: 'methodParams.amount2', multicallKey: 'amount2' },
            { key: 'methodParams.decimals2', multicallKey: 'decimals2' },
            { key: 'methodParams.decimalsOut', multicallKey: 'decimalsOut' },
        ],
        tupleName: 'addends',
    },
    addPluginOnInit: true,
    withPluginOutputs: true,
});
